<div class="upload-overlay" *ngIf="uploads.length > 0" [class.collapsed]="collapsed">
  <div class="overlay-header" (click)="toggleCollapsed()">
    <span class="title">{{ 'FILEUPLOAD.uploadsTitle' | translate: { count: uploads.length } }}</span>
    <span class="header-actions">
      <button
        *ngIf="allTerminal"
        type="button"
        class="dismiss-all"
        (click)="dismissAll($event)"
        aria-label="Dismiss all"
        title="Dismiss all"
      >
        <mat-icon>done_all</mat-icon>
      </button>
      <button type="button" class="toggle" aria-label="Toggle upload panel">
        <mat-icon>{{ collapsed ? 'expand_less' : 'expand_more' }}</mat-icon>
      </button>
    </span>
  </div>
  <div class="overlay-body" *ngIf="!collapsed">
    <div *ngFor="let item of uploads; trackBy: trackById" class="overlay-row" [attr.data-phase]="item.phase">
      <div class="row-top">
        <span class="filename" [title]="item.fileName">{{ item.fileName }}</span>
        <button
          *ngIf="item.phase === 'done' || item.phase === 'error'"
          type="button"
          class="dismiss"
          (click)="dismiss(item.id)"
          aria-label="Dismiss"
        >
          <mat-icon>close</mat-icon>
        </button>
      </div>
      <ng-container *ngIf="item.phase !== 'hashing'; else hashingTpl">
        <div class="bar">
          <div class="bar-fill" [style.width.%]="item.pct"></div>
        </div>
      </ng-container>
      <ng-template #hashingTpl>
        <div class="preparing">
          <span class="km-spinner" aria-hidden="true"></span>
          <span class="preparing-label">{{
            'FILEUPLOAD.preparingWithPct' | translate: { pct: (item.pct | number: '1.0-0') }
          }}</span>
        </div>
      </ng-template>
      <div class="row-bottom">
        <span class="phase">{{ 'FILEUPLOAD.PHASE.' + item.phase | translate }}</span>
        <span class="pct" *ngIf="item.phase !== 'hashing'">{{ item.pct | number : '1.0-0' }}%</span>
      </div>
      <div class="message" *ngIf="item.message">{{ item.message }}</div>
      <div class="message error-text" *ngIf="item.error">{{ item.error }}</div>
    </div>
  </div>
</div>
